// extracted by mini-css-extract-plugin
module.exports = {"contenedorTexto":"Indice__contenedorTexto__1Rob4","fondoIndice":"Indice__fondoIndice__33N9R","backGroundIndex":"Indice__backGroundIndex__30T-i","sg":"Indice__sg__aX9DV"};